if(!customElements.get('scroll-observer')) {
  class ScrollObserver extends HTMLElement {
    constructor() {
      super();

      this.elObserve = this.querySelector('[data-observe]');
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          const { boundingClientRect, rootBounds } = entry;
          const hasPassed = boundingClientRect.y < rootBounds.height;
          this.classList.toggle('scroll-intersecting', entry.isIntersecting)
          this.classList.toggle('scroll-passed', hasPassed);
        });
      });

      this.observer.observe(this.elObserve);
    }
  }

  customElements.define('scroll-observer', ScrollObserver);
}